import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@dnb/eufemia/components';
import { information_circled_medium } from '@dnb/eufemia/icons';
import { translationKeys } from '@pm-netbank/translations';
import ApplicationRequirementItem from '../../ApplicationRequirementItem/ApplicationRequirementItem';

const PersonalInfoRequirementItem = () => {
  return (
    <ApplicationRequirementItem
      title={
        <FormattedMessage
          id={
            translationKeys.becomeCustomer
              .become_customer_start_application_personal_info_title
          }
        />
      }
      message={
        <FormattedMessage
          id={
            translationKeys.becomeCustomer
              .become_customer_start_application_personal_info_message
          }
        />
      }
      icon={<Icon icon={information_circled_medium} />}
    />
  );
};

export default PersonalInfoRequirementItem;
